export function sidebarSessionBoundary<T extends { id: string }>(
  sessions: readonly T[],
  limit: number,
  pinnedIds: readonly string[],
) {
  const pinned = new Set(pinnedIds)
  const selected = new Set(
    sessions
      .filter((session) => !pinned.has(session.id))
      .slice(0, Math.max(0, limit))
      .map((session) => session.id),
  )
  for (const session of sessions) {
    if (pinned.has(session.id)) selected.add(session.id)
  }
  return sessions.filter((session) => selected.has(session.id))
}
